import { render, staticRenderFns } from "./TaskRepeat.vue?vue&type=template&id=3537275f"
import script from "./TaskRepeat.vue?vue&type=script&lang=js"
export * from "./TaskRepeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports